function handleSearchEvent(e, root) {
  const searchButton = root.querySelector('.cludo-input-form__search-button');
  const searchInput = root.querySelector('.cludo-input-form__input');
  searchButton.dataset.text = searchInput.value;
}

export function initializeProductSearch() {
  const root = document.getElementsByClassName('cludo-product-search-results');
  if (typeof root === 'undefined' || root.length === 0) return;
  const searchInput = root[0].querySelector('.cludo-input-form__input');
  searchInput.addEventListener('change', (e) => handleSearchEvent(e, root[0]));
}
